
import { Link } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";

export const Footer = () => {
    
  const { t } = useAppTranslation();

    return (
        <footer>
            <div className="container">
            
            {/* <!-- reg oxiri -->
            <!-- SECTION BOSHI --> */}
            <div className="section1">
                <Link className="logo" to="/">
                    <span>{t('logo')}</span>
                    <p>{t('logoSub')}</p>
                </Link>
            </div>
            {/* <!-- SECTION1 OXIRI -->
            <!-- SECTION2 BOSHI --> */}
            <div className="section2">
                <div className="tels">
                    <div className="tel1">
                        <p className="tel">{t('tel')}</p>
                    </div>    

                    
                    <div className="tel2">
                        <p className="tel">{t('mail')}</p>
                    </div>
                
                
                    <div className="location">
                        <p className="locate">{t('addressFooter')}</p>
                        
                    </div>
                </div>
            
            </div>
            {/* <!-- SECTION2 OXIRI -->
            <!-- SECTION3 BOSHI --> */}
            <div className="section3">
                <p className="legal">{t('legalFoo')}</p>
                <div className="information">
                    <p className="part">{t('legal1')} <span>{t('legal2')}</span> {t('legal3')}</p>
                </div>
            </div>
                {/* <!-- SECTION3 OXIRI --> */}
                <div className="footer">
                    <p className="copy">&copy;{t('yearFoo')},</p>
                    <p className="award">{t('infoFoo')}</p>
                </div>

            </div>
        </footer>
    )



}